export const MuiListItemIcon = {
    styleOverrides: {
        root: {
            minWidth: "unset",
            marginInlineEnd: "8px"
        }
    }
};
//# sourceMappingURL=ListItemIcon.js.map